import React, { useMemo } from 'react';
import { WorkspaceShell } from '../../app/WorkspaceShell';
import { SideNav } from '../../components/nav/SideNav';
import { TasksPanel } from '../../panels/TasksPanel';
import { FilesPanel } from '../../panels/FilesPanel';
import { ChatPanel } from '../../panels/ChatPanel';
import { BeeMonitorPanel } from '../../panels/BeeMonitor';
import { BuildStackPanel } from '../../panels/BuildStackPanel';
import { HiveCtlBridge } from '../../panels/HiveCtlBridge';
import { SettingsPanel } from '../../panels/SettingsPanel';
import { BuilderPanel } from '../../panels/BuilderPanel';

export const HiveCoreWorkstationPage: React.FC = () => {
    const tabs = useMemo(
        () => [
            {
                sceneId: 'hivecore.tasks',
                title: 'Tasks',
                closable: false,
                render: () => <TasksPanel />,
            },
            { sceneId: 'hivecore.files', title: 'Files', render: () => <FilesPanel /> },
            { sceneId: 'hivecore.chat', title: 'Chat', render: () => <ChatPanel /> },
            { sceneId: 'hivecore.bees', title: 'Bee Monitor', render: () => <BeeMonitorPanel /> },
            { sceneId: 'hivecore.build', title: 'BuildStacks', render: () => <BuildStackPanel /> },
            { sceneId: 'hivecore.hivectl', title: 'HiveCtl', render: () => <HiveCtlBridge /> },
            { sceneId: 'hivecore.builder', title: 'Builder', render: () => <BuilderPanel /> },
            { sceneId: 'hivecore.settings', title: 'Settings', render: () => <SettingsPanel /> },
        ],
        []
    );

    return <WorkspaceShell SideNav={<SideNav />} initialTabs={tabs} />;
};

export default HiveCoreWorkstationPage;
